import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import fr from 'vuetify/src/locale/fr'
import '@fortawesome/fontawesome-free/css/all.css' // Ensure you are using css-loader

Vue.use(Vuetify)

import light from '../theme/light'
import dark from '../theme/dark'

export default new Vuetify({
    lang: {
        locales: { fr },
        current: 'fr'
    },
    icons : {
        iconfont : 'fa'
    },
    theme: {
        // Pour rajouter des variantes de couleurs pour les themes ou des nouveaux thèmes,
        // vous devez créer des nouvelles propriétés dans l'interface située ".\node_modules\vuetify\types\services\theme.d.ts"
        themes: {
            light,
            dark
        }
    },
    options: {
        customProperties: true,
        themeCache: {
            get: (key: string) => localStorage.getItem(key),
            set: (key: string, value: string) => localStorage.setItem(key, value)
        }
    }
})
